var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNomadIcon = function SvgNomadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.005 0 1.74 6v12l10.255 6 10.265-6V6L12.005 0Zm4.58 13.205-2.735 1.598-3.306-1.832V16.8l-3.101 1.992V10.8l2.464-1.53 3.417 1.828V7.19l3.26-1.983v7.997Z",
    fill: "currentColor"
  })));
};

export default SvgNomadIcon;